import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import SectionContainer from '../layout/SectionContainer.jsx';
import ContentContainer from '../layout/ContentContainer.jsx';
import Options from '../components/Options.jsx';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { getTextDefaults } from './translations/PlayitSectionTranslation.js';

const PLAYIT_LANGUAGES = [
	{ value: 'de', label: 'Deutsch' },
	{ value: 'en', label: 'English' },
	{ value: 'fr', label: 'Français' },
	{ value: 'hr-HR', label: 'Hrvatski' },
	{ value: 'lt-LT', label: 'Lietuvių' },
	{ value: 'nl', label: 'Nederlands' },
	{ value: 'pl', label: 'Polski' },
	{ value: 'pt', label: 'Português' },
	{ value: 'ro', label: 'Română' },
	{ value: 'sk-SK', label: 'Slovenčina' },
];

const PlayitSection = ({ values, selectedLanguage: selectedLanguageProp = 'EN', textOverride = {} }) => {
	// Pre-fill dropdown if selectedLanguage matches a Playit language
	const normalizedSelectedLang = selectedLanguageProp.toLowerCase().split('-')[0];
	const params = new URLSearchParams(window.location.search);
	const auth = params.get('auth');
	const matchingPlayitLang = PLAYIT_LANGUAGES.find(
		(lang) => lang.value.toLowerCase().split('-')[0] === normalizedSelectedLang,
	);

	// Check if task is already pending (has playit credentials from previous redirect)
	const isPendingTask = !!values.playitUserId && !!values.languageId && !!values.playitUserKey;

	const [selectedLanguageState, setSelectedLanguageState] = useState(matchingPlayitLang?.value || '');

	// Use saved languageId if available, otherwise fall back to selectedLanguage prop
	const effectiveLanguage = values.languageId || selectedLanguageProp;
	const text = Object.assign({}, getTextDefaults(effectiveLanguage), textOverride);

	const redirectToPlayit = (languageId) => {
		const origin = window.location.origin;
		let urlToOpen = '';
		if (!languageId) {
			urlToOpen = `${origin}/api/tasks/${values.taskId}/external?redirect=true&auth=${auth}`;
		} else {
			urlToOpen = `${origin}/api/tasks/${values.taskId}/external?languageId=${languageId}&redirect=true&auth=${auth}`;
		}
		// window.open(urlToOpen, '_blank');
		window.parent.postMessage({ close: true, urlToOpen }, '*');
	};

	const handleContinue = async () => {
		if (!selectedLanguageState && !values.languageId) return;
		// Redirect with language as query parameter
		redirectToPlayit(selectedLanguageState || values.languageId);
	};
	// Show language selection (first time opening task)
	return (
		<SectionContainer style={{ justifyContent: 'center' }}>
			<ContentContainer>
				{!values.languageId && (
					<>
						<Typography variant="h6" gutterBottom>
							{text.selectLanguageTitle}
						</Typography>
						<Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
							{text.selectLanguageDescription}
						</Typography>
						<Options
							name="languageId"
							label={text.languageLabel}
							value={selectedLanguageState}
							options={PLAYIT_LANGUAGES}
							onChange={(e) => setSelectedLanguageState(e.target.value)}
							required
						/>{' '}
					</>
				)}
				<Button
					variant="contained"
					size="large"
					endIcon={<ArrowForwardIcon />}
					onClick={handleContinue}
					disabled={!selectedLanguageState && !values.languageId}
					sx={{ width: '100%', height: 56, mt: 2 }}
				>
					{text.continueButton}
				</Button>
			</ContentContainer>
		</SectionContainer>
	);
};

PlayitSection.type = 'PlayitSection';
PlayitSection.hasNavigation = true;

export default PlayitSection;
